module.exports = __webpack_public_path__ + "static/people_pop13-1609148c80cdff829ed4e893040bf77d.png";